import { __assign } from "tslib";
/** @deprecated See the [feature config decision doc](docs/decisions/002-external-feature-config.md) */
var resolveInitialToggleableFeatureOptions = function (params) {
    var _a;
    var Model = params.Model, consumerOptions = params.consumerOptions;
    // Determine enabled status based on the consumer options or the default value
    var isEnabled = (_a = consumerOptions.enabled) !== null && _a !== void 0 ? _a : new Model().enabled;
    // Features take precedence over consumer options
    if ('toggles' in params && 'featureKey' in params) {
        isEnabled = params.toggles.internal.features.isEnabledWithFallback(params.featureKey, isEnabled);
    }
    return __assign(__assign({}, consumerOptions), { enabled: isEnabled });
};
export { resolveInitialToggleableFeatureOptions };
//# sourceMappingURL=resolveInitialToggleableFeatureOptions.js.map